function getLabelText({ key, text }) {
  if (typeof window !== 'undefined' && window.app && typeof window.app.$t === 'function') {
    if (typeof key === 'string') {
      return window.app.$t(key) === key ? text : window.app.$t(key)
    } else if (Array.isArray(key)) {
      // key 为数组时按数组顺序拼接文案，数组项允许同时包含 i18n key 和普通静态文本。
      let label = ''
      key.forEach((item) => {
        // 包含 "." 的数组项按 i18n key 处理，先调用 $t 尝试翻译。
        // 如果 $t 未命中翻译，通常会把入参原样返回；此时继续追加原 item，保持数组拼接的兜底语义。
        if (item.indexOf('.') !== -1) {
          const translatedText = window.app.$t(item)
          label += translatedText === item ? item : translatedText
          return
        }
        // 不包含 "." 的数组项认为是普通静态文本，直接拼接，避免标点、单位、空格等内容被误当作翻译 key。
        label += item
      })
      return label
    } else {
      // key 既不是字符串也不是数组时，返回调用方传入的兜底文本，避免异常类型导致 forEach 报错。
      return text
    }
  } else {
    return text
  }
}
/**
 * 生成下拉列表数据
 * @param {Object} options 选项
 * @param {Object} options.constants 常量枚举
 * @param {Object} options.map 常量枚举的映射
 * @param {string} [options.labelField=label] 选项的文字属性名称，默认label
 * @param {string} [options.valueField=value] 选项的值属性名称，默认value
 * @return {Array<Object>} 下拉列表数据
 */
function createSelectList({ constants, map, labelField = 'label', valueField = 'value' }) {
  const list = []

  // 遍历常量对象
  for (const key in constants) {
    if (Object.hasOwnProperty.call(constants, key)) {
      const value = constants[key]

      list.push({
        [labelField]: map[value] || '',
        [valueField]: value
      })
    }
  }

  return list
}

/**
 * 打开爱番番弹窗
 * @param {string} url 爱番番窗口url
 * @param {number} iWidth 窗口的宽度，默认793
 * @param {number} iHeight 窗口的高度，默认663
 */
function openAiFanFanContact(url, iWidth = 793, iHeight = 663) {
  let iTop = (window?.screen.height - 30 - iHeight) / 2
  let iLeft = (window?.screen.width - 10 - iWidth) / 2

  window?.open(url, 'small', `width=${iWidth},height=${iHeight},toolbar=no,status=no,top=${iTop},left=${iLeft}`)
}
function isVAT() {
  return localStorage.getItem('platform') === '00'
}
function isIPP() {
  return localStorage.getItem('platform') === '01'
}
function debounce(func, wait = 500) {
  let timeout
  return function() {
    let context = this
    let args = arguments

    if (timeout) clearTimeout(timeout)

    timeout = setTimeout(() => {
      func.apply(context, args)
    }, wait)
  }
}
function throttle(func, delay) {
  let timer = null
  return function() {
    let context = this
    let args = arguments
    if (!timer) {
      timer = setTimeout(function() {
        func.apply(context, args)
        timer = null
      }, delay)
    }
  }
}

// 监听元素是否进入了视窗内展示
class IntersectionObserverService {
  constructor(options) {
    this.observer = new IntersectionObserver(
      (entries, observer) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            if (options.onIntersecting) {
              options.onIntersecting(entry.target, entry)
            }
          } else {
            if (options.onNotIntersecting) {
              options.onNotIntersecting(entry.target, entry)
            }
          }
        })
      },
      {
        root: null,
        rootMargin: '0px',
        threshold: 1.0,
        ...options
      }
    )
  }

  observe(target) {
    this.observer.observe(target)
  }

  unobserve(target) {
    this.observer.unobserve(target)
  }

  disconnect() {
    this.observer.disconnect()
  }
}

function globalThis() {
  if (process.server) {
    return process.env
  }
  return typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : this
}

// 权限检查方法 - 按钮
function checkPermission(value) {
  // userId=1直接拥有所以权限
  const userId = app.$store?.getters.userId
  if (userId === 1) return true
  // if (document.domain == '127.0.0.1' || document.domain == 'localhost') return true
  // if (process.env.NODE_MODE === 'development') return true
  // 获取用户按钮权限
  let isExist = false
  const dynamicButtons = app.$store?.getters.buttons || []
  if (dynamicButtons === undefined || dynamicButtons === null || dynamicButtons.length < 1) {
    return isExist
  }
  dynamicButtons.forEach((button) => {
    if (button === value) {
      isExist = true
      return isExist
    }
  })
  return isExist
}

// 权限检查 - 菜单
function checkPermissionMenu(value) {
  // userId=1直接拥有所以权限
  const userId = app.$store?.getters.userId
  if (userId === 1) return true

  let isExist = false
  const dynamicMenus = app.$store?.getters.menus || []
  console.log(dynamicMenus,'dynamicMenus>>>')
  if (dynamicMenus === undefined || dynamicMenus === null || dynamicMenus.length < 1) {
    return isExist
  }
  dynamicMenus.forEach((menu) => {
    if (menu.menuKey === value) {
      isExist = true
      return isExist
    }
  })
  return isExist
}

export { isVAT, isIPP, debounce, throttle, createSelectList, openAiFanFanContact, IntersectionObserverService, globalThis, checkPermission, checkPermissionMenu, getLabelText }



// WEBPACK FOOTER //
// /data/.jenkins/workspace/ost-prod/@ost/lib/utils.js